import script from "./MedicalData.vue?vue&type=script&setup=true&lang=js"
export * from "./MedicalData.vue?vue&type=script&setup=true&lang=js"

import "./MedicalData.vue?vue&type=style&index=0&id=465c8ba0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-465c8ba0"]])

export default __exports__